import { useEffect, useState } from "react";
import "./theme.css";

const card = {
  border: "1px solid var(--audit-border)",
  borderRadius: 8,
  background: "var(--audit-bg-subtle)",
  padding: "12px 14px",
  marginBottom: 14,
};
const h3 = { fontSize: 14, fontWeight: 800, margin: "0 0 8px" };
const li = { fontSize: 13, lineHeight: 1.9 };
const pill = {
  fontSize: 12.5,
  padding: "5px 11px",
  border: "1px solid var(--audit-border)",
  borderRadius: 12,
  color: "var(--audit-accent)",
  textDecoration: "none",
};

export default function SimplifiedRatePage() {
  const [d, setD] = useState(null);

  useEffect(() => {
    fetch("/api/onto/simplified-rate")
      .then((r) => r.json())
      .then(setD)
      .catch(() => setD({}));
  }, []);

  const links = d?.links || {};

  return (
    <div
      className="audit-root"
      style={{
        height: "100%",
        overflow: "auto",
        background: "var(--audit-bg)",
        padding: "18px 22px",
      }}
    >
      <div style={{ maxWidth: 820 }}>
        <h2 style={{ fontSize: 17, fontWeight: 800, margin: "0 0 4px" }}>
          간이세율 (관세법 제81조)
        </h2>
        <div
          style={{
            fontSize: 12.5,
            color: "var(--audit-text-muted)",
            marginBottom: 14,
          }}
        >
          여행자 휴대품·소액 특송/우편물 등에 관세와 내국세를 묶어 부과하는
          단일(품목류별) 세율 제도.
        </div>

        {d === null ? (
          <div style={{ fontSize: 13, color: "var(--audit-text-muted)" }}>
            불러오는 중…
          </div>
        ) : !d.conditions ? (
          <div style={{ fontSize: 13, color: "var(--audit-text-muted)" }}>
            데이터를 불러오지 못했습니다.
          </div>
        ) : (
          <>
            {/* 적용조건 */}
            <div style={card}>
              <div style={h3}>적용 대상 (간이세율이 적용되는 경우)</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {(d.conditions || []).map((c, i) => (
                  <li key={i} style={li}>
                    {c}
                  </li>
                ))}
              </ul>
            </div>

            {/* 배제 */}
            <div style={card}>
              <div style={h3}>적용 배제 (일반세율로 과세)</div>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {(d.excludes || []).map((c, i) => (
                  <li key={i} style={li}>
                    {c}
                  </li>
                ))}
              </ul>
            </div>

            {/* 세율표 */}
            <div style={{ ...card, background: "var(--audit-bg)" }}>
              <div style={h3}>
                간이세율표{" "}
                <span
                  style={{
                    fontSize: 10.5,
                    fontWeight: 700,
                    padding: "1px 6px",
                    borderRadius: 3,
                    background: "#fef3c7",
                    color: "#92400e",
                    marginLeft: 4,
                  }}
                >
                  참고용
                </span>
              </div>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: 13,
                }}
              >
                <thead>
                  <tr
                    style={{
                      textAlign: "left",
                      color: "var(--audit-text-muted)",
                    }}
                  >
                    <th
                      style={{
                        padding: "6px 8px",
                        borderBottom: "1px solid var(--audit-border)",
                      }}
                    >
                      품목류
                    </th>
                    <th
                      style={{
                        padding: "6px 8px",
                        borderBottom: "1px solid var(--audit-border)",
                        width: 90,
                      }}
                    >
                      세율
                    </th>
                    <th
                      style={{
                        padding: "6px 8px",
                        borderBottom: "1px solid var(--audit-border)",
                        width: 90,
                      }}
                    >
                      비고
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(d.table || []).map((row, i) => (
                    <tr key={i}>
                      <td
                        style={{
                          padding: "7px 8px",
                          borderBottom: "1px solid var(--audit-border)",
                        }}
                      >
                        {row.category}
                      </td>
                      <td
                        style={{
                          padding: "7px 8px",
                          borderBottom: "1px solid var(--audit-border)",
                          fontWeight: 700,
                        }}
                      >
                        {row.rate}
                      </td>
                      <td
                        style={{
                          padding: "7px 8px",
                          borderBottom: "1px solid var(--audit-border)",
                          color: "var(--audit-text-muted)",
                        }}
                      >
                        {row.note}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div
                style={{
                  fontSize: 11.5,
                  color: "var(--audit-text-faint)",
                  marginTop: 8,
                }}
              >
                ※ {d.note}
              </div>
            </div>

            {/* 근거·도구 */}
            <div
              style={{
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
                marginTop: 4,
              }}
            >
              {links.customs && (
                <a
                  href={links.customs}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    ...pill,
                    borderColor: "var(--audit-accent)",
                    fontWeight: 600,
                  }}
                >
                  관세청 — 여행자 휴대품 예상세액 조회 ↗
                </a>
              )}
              {links.law && (
                <a href={links.law} target="_blank" rel="noreferrer" style={pill}>
                  law.go.kr — 관세법 제81조 ↗
                </a>
              )}
              {links.ordinance && (
                <a
                  href={links.ordinance}
                  target="_blank"
                  rel="noreferrer"
                  style={pill}
                >
                  law.go.kr — 시행령 별표2 ↗
                </a>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
